import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Container,
  Button,
  Tooltip,
  Chip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles(() => ({
  evenRow: {
    backgroundColor: "#D0EFFF",
  },
  oddRow: {
    backgroundColor: "#FFFFFF",
  },
}));
const TicketTable = () => {
  const classes = useStyles();
  const [userTickets, setUserTickets] = useState([]);
  const navigate = useNavigate();

  // Sample data for the table

  const fetchTickets = async () => {
    try {
      const userId = sessionStorage.getItem("userId");

      if (!userId) {
        throw new Error("User ID not found in sessionStorage");
      }

      const response = await axios.get(
        "https://apisupport.ipaisa.co.in/supportapp/auth/ticket/getbyuser",
        {
          headers: {
            userid: userId,
          },
        }
      );

      setUserTickets(response.data);
      console.log("Fetched tickets:", response.data);
    } catch (error) {
      console.error("Error fetching tickets:", error.message);
    }
  };

  const createChat = (id) => {
    navigate(`/ticketdetail/${id}`);
  };

  const handleChatSessionClick = () => {
    navigate("/chatsession"); // Navigate to '/dashboard' on click
  };

  const isWithinChatTime = () => {
    const now = new Date();
    const start = new Date();
    const end = new Date();

    start.setHours(10, 30, 0); // 10:30 AM
    end.setHours(18, 30, 0); // 6:30 PM

    return now >= start && now <= end;
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  return (
    <Container style={{ padding: "2rem", marginTop: "calc(3% + 56px)" }}>
      <TableContainer
        component={Paper}
        sx={{
          maxWidth: "100%",
          overflowX: "auto",
          borderRadius: "16px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
        }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#027BFE" }}>
              {[
                "Ticket ID",
                "Customer Name",
                "Issue Type",
                "Status",
                "Message/Reason",
                "Assignee Agent",
                "Created Date",
                "Last Updated",
                "Chat",
              ].map((header) => (
                <TableCell
                  key={header}
                  sx={{
                    color: "#FFF",
                    fontWeight: "bold",
                    fontSize: "0.95rem",
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {userTickets.map((row, index) => {
              const statusColorMap = {
                ASSIGNED: "info",
                APPROVED: "primary",
                ONGOING: "warning",
                COMPLETED: "success",
                OPEN: "primary",
                WAITING: "warning",
                REJECTED: "error",
              };

              return (
                <TableRow
                  key={row.id}
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                    transition: "background-color 0.3s ease",
                    ":hover": { backgroundColor: "#e3f2fd" },
                  }}
                >
                  <TableCell>{row.id}</TableCell>
                  <TableCell>{row.username}</TableCell>
                  <TableCell>{row.issueType}</TableCell>
                  <TableCell>
                    <Chip
                      label={row.status}
                      color={
                        statusColorMap[row.status?.toUpperCase()] || "default"
                      }
                      variant="outlined"
                      size="small"
                    />
                  </TableCell>
                  <TableCell>{row?.reason || "N/A"}</TableCell>
                  <TableCell>{row?.trackBy?.empName || "N/A"}</TableCell>
                  <TableCell>
                    {new Date(row?.date).toLocaleString() || "N/A"}
                  </TableCell>
                  <TableCell>
                    {row.date_completion
                      ? new Date(row?.date_completion).toLocaleString()
                      : "N/A"}
                  </TableCell>
                  <TableCell>
                    <Tooltip
                      title={
                        !isWithinChatTime()
                          ? "Support chat is available from 10:30 AM to 6:30 PM"
                          : "Start Chat"
                      }
                    >
                      <span>
                        <Button
                          onClick={handleChatSessionClick}
                          disabled={!isWithinChatTime()}
                          variant="contained"
                          color="primary"
                          size="small"
                          sx={{
                            borderRadius: 3,
                            textTransform: "none",
                            px: 2,
                            py: 1,
                            fontSize: "0.85rem",
                            fontWeight: 600,
                            ":hover": {
                              backgroundColor: "#0369d1",
                            },
                          }}
                        >
                          Go To Chat
                        </Button>
                      </span>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default TicketTable;
